import React, {Component, useContext, useEffect, useState} from 'react';
import {connect} from "react-redux";
import {
    receiveApiTokenWeb3,
} from "../../services/user/actions";
import Web3Button from "../Login/Web3Button";

function TransferToWeb3 (props) {
    useEffect(()=>{
        document.title = "TransferToWeb3";
    }, [])


        return (
            <div className="App-container">
                <div className="App-blur-bg">

                </div>
                <div className="App-transfter-to-web3">
                    <div className="App-top">
                        <div className="entry-content">
                            <h1 className="App-title">An Important Update About Web3 Transition</h1>
                            <div className="d-flex">
                                <p className="text-white" style={{paddingRight:"1rem", alignSelf: "center"}}>
                                    Hello! we are transitioning to self-custody decentralized account model to increase
                                    security.<br/>
                                    Please connect your decentralized wallet to transition your account.
                                    {/*<br/>
                                    <br/>
                                    <a href="#">Read more about the transition.</a>*/}
                                </p>
                                <div style={{paddingBottom:"2rem",minWidth:"24rem"}}>
                                    <Web3Button/>
                                </div>
                            </div>

                            <div className="d-flex justify-content-between">
                                <div className="text-main">
                                    <p className="text-center">
                                        <br/>
                                        <strong>
                                            Don’t have a decentralized wallet?<br/>
                                            Here are some popular choices.
                                        </strong>
                                    </p>
                                </div>
                                <div className="App-transfter-to-web3__icons">

                                    <div className="row">
                                        <div className="col-4">
                                            <div className="App-transfter-to-web3__icons__item">
                                            <img src="/ui/assets/web3/metamask.svg" className="web3-logo-1"/>
                                            </div>
                                        </div>
                                        <div className="col-4 text-center">
                                            <div className="App-transfter-to-web3__icons__item">
                                            <img src="/ui/assets/web3/rabby.svg" className="web3-logo-2"/>
                                            </div>
                                        </div>
                                        <div className="col-4 text-end">
                                            <div className="App-transfter-to-web3__icons__item">
                                            <img src="/ui/assets/web3/phantom.svg" className="web3-logo-3"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
}
const mapStateToProps = function (state) {
    return {
        logged: state.user.logged,
        user: state.user.user,
        apiToken: state.user.apiToken,
        is2FA: state.user.is2FA,
        credentials: state.user.credentials,
        flashError: state.user.flashError
    }
};


export default connect(mapStateToProps, {
    receiveApiTokenWeb3
})(TransferToWeb3);
